import React from 'react';
import { i18n } from '@lt/localization';
import { FilterGroup, Switcher } from '@lt/components';
import type { IFilter } from '../types';

const FILTER_NAME = 'line';
const FILTER_LABEL = i18n.t('filters.line.title');

const FilterLine = ({
  data,
  className = '',
  isMobile = false,
  onChange,
  onClear,
}: IFilter): JSX.Element => {
  const handleChange = (clickedItem) => {
    const diff = data.map(({ id, selected }) => ({
      id,
      selected: id === clickedItem.id && !selected,
    }));

    onChange({ path: FILTER_NAME, diff });
  };
  const list = data.map((button) => {
    const lineNumber = button.id;
    const postfix =
      lineNumber === 1
        ? i18n.t('filters.line.number_line')
        : i18n.t('filters.line.number');

    return {
      ...button,
      label: `${lineNumber}${postfix}`,
    };
  });

  return (
    <FilterGroup
      className={className}
      label={FILTER_LABEL}
      showClearBtn={data.some((item) => item.selected)}
      onClear={() => onClear(FILTER_NAME)}
      isMobile={isMobile}
    >
      <Switcher
        list={list}
        onChange={handleChange}
        order="desc"
        isMobile={isMobile}
      />
    </FilterGroup>
  );
};

export default Object.assign(FilterLine, {
  filterName: FILTER_NAME,
  filterLabel: FILTER_LABEL,
  valuesLabel: (data) =>
    i18n.t('filters.line.value', {
      number: `${data.find((item) => item.selected).id}`,
    }),
});
